<script setup lang="ts">
import { type ShallowRef, shallowRef, watchEffect } from 'vue'
import { Primitive } from 'radix-vue'
import VIcon from '../VIcon/VIcon.vue'
import type { IIconButtonProps } from './types'
import { VIconButtonVariants } from './types'
import { useIconButtonConfig } from './composables/useIconButtonConfig'
import { SIZES } from '@/ui/ts/types/Sizes'
import { isDark } from '@/lib/utils'

const props = withDefaults(defineProps<IIconButtonProps>(), {
    variant: VIconButtonVariants.primary,
    as: 'button',
    size: SIZES.MEDIUM,
    disabled: false,
    dark: false,
    class: '',
})

const iconButtonConfig: ShallowRef<Record<string, string>> = shallowRef({} as Record<string, string>)

watchEffect(() => {
    iconButtonConfig.value = useIconButtonConfig(props)
})
</script>

<template>
    <Primitive
        :as="to || href ? 'a' : as"
        :as-child="asChild"
        :class="[iconButtonConfig.rootClasses, isDark(dark), props.class]"
        :data-test="`icon-button-${dataTest}`"
        :to="to"
        :href="href"
        data-gpp-tools-ui
    >
        <VIcon
            :name="icon"
            :size="size"
        />
    </Primitive>
</template>
